import { render, staticRenderFns } from "./CommodityMarketingDiscussItemVideos.vue?vue&type=template&id=dc12e1ee&scoped=true&"
import script from "./CommodityMarketingDiscussItemVideos.vue?vue&type=script&lang=js&"
export * from "./CommodityMarketingDiscussItemVideos.vue?vue&type=script&lang=js&"
import style0 from "./CommodityMarketingDiscussItemVideos.vue?vue&type=style&index=0&id=dc12e1ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc12e1ee",
  null
  
)

export default component.exports